import {staticUrl} from 'ladder/build2'

type PreferredCarrier = 'preferred-carrier/imo' | string; // todo enumerate

export function preferredCarrierToUwGuidelinesUrl(carrier: PreferredCarrier): string { // AI port
    switch (carrier) {
        case 'preferred-carrier/imo':
            return staticUrl("/pdfs/agents/prosperity-imo-underwriting-guidelines.pdf");
        default:
            return staticUrl("/pdfs/agents/general-underwriting-guidelines.pdf");
    }
}

export function complianceManualUrl(topLevelAgencyLddrSource) {
  switch (topLevelAgencyLddrSource) {
    case 'prosperity-imo':
      return staticUrl('/pdfs/agents/imo/ladder-agent-compliance-manual-imo.pdf')
    default:
      return staticUrl('/pdfs/agents/ladder-agent-compliance-manual.pdf')
  }
}
